import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { GiSattelite, GiRadarSweep, GiAbstract002 } from "react-icons/gi";
import { RiBaseStationLine } from "react-icons/ri";
import { useRadarOrSatelite } from "../../contexts/RadarOrSatelite";
import mapControls from "../map/mapControls.module.css";

const tabs: Array<{ key: string; label: string; path: string; icon: React.ReactNode }> = [
  { key: "radar", label: "Radar", path: "/", icon: <GiRadarSweep /> },
  { key: "satellite", label: "Satélite", path: "/satelite", icon: <GiSattelite /> },
  { key: "station", label: "Estações", path: "/estacoes", icon: <RiBaseStationLine /> },
  { key: "wrf", label: "WRF", path: "/wrf", icon: <GiAbstract002 /> },
];

const getTabFromPath = (pathname: string): string => {
  if (pathname.includes("satelite")) return "satellite";
  if (pathname.includes("estacoes")) return "station";
  if (pathname.includes("wrf")) return "wrf";
  return "radar";
};

// Coluna flutuante que alterna entre os produtos (Radar, Satélite, Estações, WRF).
// Só Estações ainda tem menu lateral — os demais têm seus controles no player.
const ProductSwitcher: React.FC = () => {
  const { handleTypeMecanism } = useRadarOrSatelite();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedTab, setSelectTab] = useState<string>(getTabFromPath(location.pathname));
  const [mounted, setMounted] = useState(false);

  useEffect(() => { setMounted(true); }, []);

  useEffect(() => {
    setSelectTab(getTabFromPath(location.pathname));
  }, [location.pathname]);

  useEffect(() => {
    handleTypeMecanism(selectedTab);
  }, [selectedTab, handleTypeMecanism]);

  const handleTabClick = (tab: string) => {
    setSelectTab(tab);
    const t = tabs.find(x => x.key === tab);
    if (t) navigate(t.path);
    if (tab === "station") {
      try {
        window.dispatchEvent(new CustomEvent("products:openMenu"));
      } catch { /* ignore */ }
    }
  };

  if (!mounted) return null;

  const el = (
    <div
      className="playerButtons"
      style={{
        position: "fixed",
        right: "360px",
        top: "50%",
        transform: "translateY(-50%)",
        display: "flex",
        flexDirection: "column",
        gap: 10,
        alignItems: "center",
        pointerEvents: "none",
      }}
    >
      {tabs.map(t => (
        <button
          key={t.key}
          type="button"
          className={`${mapControls.playerButton} footerPlayerButton ${
            selectedTab === t.key ? "footerPlayerButtonSelected" : ""
          }`}
          onClick={() => handleTabClick(t.key)}
          title={t.label}
          aria-pressed={selectedTab === t.key}
          style={{ pointerEvents: "auto" }}
        >
          <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
            <span style={{ lineHeight: 1 }}>{t.icon}</span>
            <span style={{ fontSize: "0.6rem", lineHeight: 1, whiteSpace: "nowrap" }}>{t.label}</span>
          </span>
        </button>
      ))}
    </div>
  );

  let target: Element | Document = document.body;
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const t = document.getElementById("app-overlays");
    if (t) target = t;
  }

  return createPortal(el, target as any);
};

export default ProductSwitcher;
